module.exports = {"15x15": __webpack_public_path__ + "images/trail-arrow-15x15.png"};